import * as o from "react";
function u() {
  return u = Object.assign ? Object.assign.bind() : function(n) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var r in e) ({}).hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }
    return n;
  }, u.apply(null, arguments);
}
function a(n, t) {
  typeof n == "function" ? n(t) : n && (n.current = t);
}
function i(...n) {
  return o.useMemo(() => n.every((t) => t == null) ? null : (t) => {
    n.forEach((e) => {
      a(e, t);
    });
  }, n);
}
function s(n, t) {
  if (n == null) return {};
  var e = {};
  for (var r in n) if ({}.hasOwnProperty.call(n, r)) {
    if (t.includes(r)) continue;
    e[r] = n[r];
  }
  return e;
}
export {
  s as _,
  u as a,
  a as s,
  i as u
};
//# sourceMappingURL=objectWithoutPropertiesLoose-Cg0fb85x.mjs.map
